<template>
  <placeholder-screen title="What to read">
    <p class="text-left">
      If you’re growing your career, chances are you’re reading even more than a developer typically does.</p>
    <p class="text-left">
      We’ll provide suggestions on what to take a look at and make it a breeze to add your choices to the Track
      Reading list.  You’ll also get a chance to see what others are reading and upvote your favorites.
    </p>
    <p>
      This feature will be available as part of the <em>Grow</em> release in January.
    </p>
  </placeholder-screen>
</template>
<script>
  import { mapActions } from 'vuex';
  import PlaceholderScreen from '../UIComponents/PlaceholderScreen.vue';
 
  export default {
    created() {
      this.setNavbarTitle('What To Read');
    },
    methods: {
      ...mapActions('UI', ['setNavbarTitle']),
    },
    components: {
      PlaceholderScreen
    }
  }

</script>
